import farmActions from './farmActions';
import {getIssueSummary,getMoistureSummary} from './farmsUtils';

// Empty fallback so the nav-filter badges render 0 rather than undefined/NaN.
const EMPTY_SUMMARY = { LOW: 0, MED: 0, FAIR: 0, EXTRACTED: 0 };

const initialState = {
    token: null,
    data: null,
    multiFarmdata:null,
    issueSummary: {},
    moistureSummary:{},
}

export default function farmsReducer(state = initialState, action) {
    
    switch (action.type) {
        case farmActions.TYPES.LOADING:
            return {
                token: action.token,
                data: null,
                meta: state.meta,
                issueSummary: state.issueSummary,
                moistureSummary:state.moistureSummary,
            };
        case farmActions.TYPES.SUCCESS:
            // Prefer the server's full-set aggregates (meta.*Summary) — they are
            // computed over the whole filtered portfolio, not just this page.
            // Fall back to the per-page client sum for non-paginated calls / older API.
            return {
                token: null,
                data: action.data,
                meta: action.meta || null,
                issueSummary: action.meta?.reportingStatusSummary || getIssueSummary(action.data) || EMPTY_SUMMARY,
                moistureSummary: action.meta?.moistureSummary || getMoistureSummary(action.data) || EMPTY_SUMMARY,
            };
        case farmActions.TYPES.FAILURE:
            return {
                token: null,
                data: action.error,
                issueSummary: null,
                moistureSummary:null,
            };
        case farmActions.TYPES.CLEAR_DATA:
            return {};
        case farmActions.TYPES.CREATING:
            return {
                ...state, isCreating: action.payload
            }
        case farmActions.TYPES.CREATE_SUCCESS:
            return {
                ...state,
                isCreating: false,
                createdFarm: action.payload
            }
        case farmActions.TYPES.CREATE_FAILURE :
            return {
                isCreating: false,
                error: action.payload
            }

        case farmActions.TYPES.SELECTED_FARM :
            // The farms-page sort flow dispatches this with a paginated page + its meta,
            // so prefer the server aggregates here too. The dashboard searchByGroups
            // selection dispatches it without meta and keeps the client sum of the selection.
            return {
                ...state,
                data: action.payload,
                meta: action.meta || null,
                issueSummary: action.meta?.reportingStatusSummary || getIssueSummary(action.payload) || EMPTY_SUMMARY,
                moistureSummary: action.meta?.moistureSummary || getMoistureSummary(action.payload) || EMPTY_SUMMARY,
                isCreating: false
            }
            case farmActions.TYPES.MULTI_SELECTED_FARM :
            return {
                    ...state,
                    multiFarmdata: action.payload
                }

          
        default:
            return state;
    }
}




